<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title" #title>Help</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item-divider color="tertiary">
            General
        </ion-item-divider>

        <ion-item [disabled]=vb.disabled detail="true" data-test="contactUs" href="javascript:;"
                (click)="onContactUsClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Contact Us</span><br />
                <span class="line2">Our contact information.</span>
            </ion-label>
        </ion-item>

        <!-- <ion-item-divider color="tertiary">
            Orientation Tours
        </ion-item-divider>

        <ion-item detail="true" href="javascript:;" (click)="showTour(20329)" data-test="vocabularyTour">
            <ion-label class="ion-text-wrap">
                <span class="line1">Vocabulary Tour</span><br />
                <span class="line2">Learn about the vocabulary terms used in ShuttleNomix.</span>
            </ion-label>
        </ion-item>

        <ion-item detail="true" href="javascript:;" (click)="showTour(20332)" data-test="workflowTour">
            <ion-label class="ion-text-wrap">
                <span class="line1">Workflow Tour</span><br />
                <span class="line2">Learn about the three user roles and their responsibilities.</span>
            </ion-label>
        </ion-item>

        <ion-item detail="true" href="javascript:;" (click)="showTour(20294)" data-test="sidemenuTour">
            <ion-label class="ion-text-wrap">
                <span class="line1">Sidemenu Tour</span><br />
                <span class="line2">Learn about the sidemenu and how to navigate from page to page.</span>
            </ion-label>
        </ion-item> -->

        <ion-item-divider color="tertiary">
            Help and Tutorials
        </ion-item-divider>

        <ion-item [disabled]=vb.disabled detail="true" data-test="tutorials" href="javascript:;"
                (click)="onOpenWebsite()">
            <ion-label class="ion-text-wrap">
                <span class="line1">ShuttleNomix YouTube Channel</span><br />
                <span class="line2">
                    All our quick-start videos, tutorials and playlists are available on our YouTube channel.
                </span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="introduction" href="javascript:;"
                (click)="onIntroductionClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Introduction</span><br />
                <span class="line2">Features, benefits and value of ShuttleNomix.</span>
            </ion-label>
        </ion-item>

        <!-- Implement this later
        <ion-item-divider>Social Proof</ion-item-divider>

        <ion-item ion-item  (click)="onTestimonialsClick()">
            <span class="line1">What others have to say</span><br />
            <span class="line2">Social proof that ShuttleNomix is well received.</span>
        </ion-item> -->

        <ion-item-divider color="tertiary">
            Talk To Us
        </ion-item-divider>

        <ion-item [disabled]=vb.disabled detail="true" data-test="messageCenter" href="javascript:;"
            (click)="onMessageCenterClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Message Center</span><br />
                <span class="line2">View important messages, alerts and announcements.</span>
            </ion-label>
            @if (unreadMessagesCount > 0) {
                <ion-badge slot="end" color="danger" data-test="messageCenterBadge">
                    {{unreadMessagesCount}}
                </ion-badge>
            }
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="feedback" href="javascript:;"
                (click)="onFeedbackClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Feedback</span><br />
                <span class="line2">Report a bug, request a feature or ask a question.</span>
            </ion-label>
        </ion-item>
        
        <!-- <ion-item [disabled]=vb.disabled detail="true" id="satisfaction" data-test="satisfaction"
                routerLink="/satisfactionPage1/" router-direction="forward">
            <ion-label class="ion-text-wrap">
                <span class="line1">Overall Satisfaction</span><br />
                <span class="line2">Please grade us.</span>
            </ion-label>
        </ion-item> -->
    </ion-list>
</ion-content>
